//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'lodash';
import editableDiv from './editable-div.vue';
import {
  parseMarkdown,
  formatTaskName,
  parseDuration,
} from '../format-task-name.js';

// Delay to save task to database, measured from the last input event
// (i.e. this is completely independent of typingStopDelay).
const kSaveDelayMs = 60 * 1000;

export default {
  props: ['task'],
  data() {
    return {
      currentValue: '',
      // DebouncedSave has to be stored in data in order to have properly
      // bound .cancel() method.
      debouncedSave: _.debounce(() => {
        this.save();
      }, kSaveDelayMs),
      edited: false,
      saved: true,
    };
  },
  components: {editableDiv},
  methods: {
    focus() {
      this.$refs.nameInput.focus();
    },
    blur() {
      this.debouncedSave.flush();
      this.$refs.nameInput.blur();
    },
    nameEdited() {
      this.edited = true;
      this.saved = false;
      this.debouncedSave();
    },
    save() {
      if (!this.task || !this.currentValue || !this.task._id) {
        return;
      }
      // contenteditable may return content with a trailing newline which
      // is actually not visible to the user while editing. Remove it.
      const name = this.currentValue.trim()
      const updatedTask = this.task.clone({name});
      const html = parseMarkdown(name);
      if (html) {
        updatedTask.html = html;
      } else {
        delete updatedTask.html;
      }
      const formattedNameTokens = formatTaskName(name);
      if (formattedNameTokens) {
        updatedTask.formattedNameTokens = formattedNameTokens;
      } else {
        delete updatedTask.formattedNameTokens;
      }
      const duration = parseDuration(this.currentValue)
      if (duration) {
        updatedTask.dur = duration;
      } else {
        delete updatedTask.dur;
      }
      updatedTask.save()
        .then(() => {
          this.saved = true;
        })
        .catch((error) => {
          // TODO: Show the error in UI, handle it sensibly.
          console.error(error);
          this.$emit('db-update-error', error);
        });
    },
    blurUnlessWithShift(event) {
      if (event.shiftKey) {
        // Keep default behavior of adding a newline.
        return;
      }
      event.preventDefault();
      this.blur();
      this.$emit('confirmed');
    },
  },
  computed: {
    // Necessary for setting up a focused watch.
    taskName() {
      return this.task.name;
    },
    forwardedListeners() {
      // 'confirmed' is our custom event. We could probably forward it anyway
      // with no harm, but let's not do that.
      const result = Object.assign({}, this.$listeners);
      delete result.confirmed;
      return result;
    },
  },
  watch: {
    taskName: {
      immediate: true, // Handle also the initial value.
      handler(newValue, oldValue) {
        if (document.activeElement === this.$refs.nameInput) {
          // The user is still editing the field. Disregard the new value.
          // Updating the field while it has focus sometimes causes
          // a race condition with user input, resulting in horribly broken
          // user experience (caret jumping mid-word, lost input, this sort
          // of things).
          return;
        }
        if (newValue === oldValue && newValue === this.currentValue) {
          return;
        }
        this.currentValue = newValue;
        this.saved = true;
        this.debouncedSave.cancel();
      },
    },
  },
  mounted() {
    this.currentValue = this.taskName;
  },
  beforeDestroy() {
    this.debouncedSave.flush();
  },
};
